// extracted by mini-css-extract-plugin
export default {"viewAll":"ViewAll_viewAll__PmHL7"};